import { useEffect } from "react";

const SITE_URL = "https://vanguardluxcarsbystekoza.com";

const setMeta = (name, content, isProperty = false) => {
  if (!content) return;
  const attr = isProperty ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (url) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const useSEO = ({ title, description, path = "", image, jsonLd } = {}) => {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | Vanguard Lux Cars`
      : "Vanguard Lux Cars — Πολυτελή Αυτοκίνητα προς Πώληση & Ενοικίαση";
    const fullDesc = description ||
      "Επιλεγμένη συλλογή από πολυτελή αυτοκίνητα στην Ελλάδα. Αγορά ή ενοικίαση με προσωπική εξυπηρέτηση από τη Vanguard Lux Cars.";
    const fullUrl = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta("description", fullDesc);
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", fullDesc, true);
    setMeta("og:url", fullUrl, true);
    setMeta("twitter:title", fullTitle, true);
    setMeta("twitter:description", fullDesc, true);
    setMeta("twitter:url", fullUrl, true);
    if (image) {
      setMeta("og:image", image, true);
      setMeta("twitter:image", image, true);
    }
    setCanonical(fullUrl);

    if (jsonLd) {
      setJsonLd("page-jsonld", jsonLd);
    } else {
      const el = document.getElementById("page-jsonld");
      if (el) el.remove();
    }
  }, [title, description, path, image, jsonLd]);
};

export { SITE_URL };
